
export class ResetState {
  static readonly type = '[ManageUsers] Reset';
}

export class DeleteUser {
  static readonly type = '[ManageUsers] Delete User';
  constructor(public userId: string, public archivedTab: boolean, public reason: string) { }
}

export class ArchiveUser {
  static readonly type = '[ManageUsers] Archive User';
  constructor(public userId: string, public reason: string) { }
}

export class RestoreUser {
  static readonly type = '[ManageUsers] Restore User';
  constructor(public userId: string) { }
}

export class SetFilter {
  static readonly type = '[ManageUsers] Set Filter';
  constructor(public filter: string) { }
}

export class DismissSilentBanner {
  static readonly type = '[ManageUsers] Dismiss Silent Banner';
}

export class DismissAiConnectionsBanner {
  static readonly type = '[ManageUsers] Dismiss AI Connections Banner';
}

export class MarkAiConnectionsColumnSeeded {
  static readonly type = '[ManageUsers] Mark AI Connections Column Seeded';
}

export class SetVisibleColumns {
  static readonly type = '[ManageUsers] Set Visible Columns';
  constructor(public visibleColumns: string[]) { }
}

export class LoadProjects {
  static type = '[ManageUsers] Load Projects';

  constructor(public skipIfAlreadyLoaded?: boolean, public showIntegration?: boolean) { }
}

export class AddProjectAccessItem {
  static type = '[ManageUsers] Add Project Access Item';

  constructor(public projectId: string, public itemId: string, public role: 'user' | 'tag') { }
}

export class RemoveProjectAccessItem {
  static type = '[ManageUsers] Remove Project Access Item';

  constructor(public projectId: string, public itemId: string, public role: 'user' | 'tag') { }
}
